import React from 'react'
import {connect} from 'react-redux'
import {sessionActions, sessionSelectors} from './redux'
import SessionWarningDialog from './SessionWarningDialog'

const SessionWarningDialogContainer = ({visible, extendingSession, onExtendClicked, onLogoutClicked}) => (
    visible && (
        <SessionWarningDialog
            extendingSession={extendingSession}
            onExtendClicked={onExtendClicked}
            onLogoutClicked={onLogoutClicked}
        />
    )
)

const mapStateToProps = (state) => ({
    visible: sessionSelectors.sessionWarningVisible(state),
    extendingSession: sessionSelectors.extendingSession(state),
})

const mapDispatchToProps = (dispatch) => ({
    onExtendClicked: () => dispatch(sessionActions.extendSession()),
    onLogoutClicked: () => dispatch(sessionActions.logOut()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SessionWarningDialogContainer);
